import { useMemo } from "react";
import { useTeamUsersQuery } from "features/manageUsers/api/useTeamUsersQuery";

export const useContactsTeamMember = (teamId: number) => {
  const { data: teamUsers = { results: [] } } = useTeamUsersQuery({
    teamId,
    limit: 300,
    sort: "email",
    serializer: "basic_info",
  });

  const teamMembersUser = useMemo(
    () =>
      teamUsers?.results
        .filter(
          (member: any) =>
            member?.profile?.first_name && member?.profile?.last_name,
        )
        .map((member: any) => ({
          value: member?.id,
          label: `${member?.profile?.first_name} ${member?.profile?.last_name}`,
        })),
    [teamUsers?.results],
  );

  return { teamMembersUser };
};
